import './style.scss'
import { AbsoluteContainer, AppText, FixedContainer, FlexColumn } from "src/style"
import { ReactComponent as DirectionIcon } from 'src/assets/img/direction.svg'
import {ReactComponent as Logo} from 'src/assets/img/crendly-logo-blue.svg'

export const MobileView = () => {
    return (
        <FixedContainer width="100" sizeUnit="%" top="0" left="0" zIndex="20" height="full">
            <FlexColumn 
                height='100' hUnit='%' width='100' sizeUnit='%' 
                bottomPadding='1.5' leftPadding='3' rightPadding='3'
                bgColor="#ffffff"
            >   
                <AbsoluteContainer top='3' left='3'>
                    <Logo />
                </AbsoluteContainer>
                <DirectionIcon className="direction-icon" />
                <AppText 
                    textSize="2.5" fontWeight='500' align='center'
                    className='mobile-view-text'
                >
                    This application can only be viewed on PC
                </AppText>
            </FlexColumn>
        </FixedContainer>
    )
}
